// extracted by mini-css-extract-plugin
export default {"fullWidth":"co-z","image":"do-z","lazyLoadPicture":"eo-z","lazyLoadSpinner":"fo-z","lazyLoadSpin":"go-z","lazyLoadImage":"ho-z","hasStyledAspectRatio":"io-z"};